import {
  FEATURE_TOGGLE_VOLUME_BASED_PRICES,
  useFeatureToggleContext,
} from '../../../../../feature-toggles'
import { useProductSearchResultItemContext } from '../../ProductSearchResultItemContext/productSearchResultItemContext'

export const useProductSearchShouldRenderVolumePricingLabel = (): boolean => {
  const {
    algoliaRecord: { best_offer },
  } = useProductSearchResultItemContext()

  const featureToggles = useFeatureToggleContext()
  if (!best_offer) {
    return false
  }

  const isVolumePricingFeatureEnabled = Boolean(
    featureToggles[FEATURE_TOGGLE_VOLUME_BASED_PRICES],
  )
  const hasVolumePricing = Boolean(
    best_offer.volume_based_prices && best_offer.volume_based_prices.length > 1,
  )

  if (!isVolumePricingFeatureEnabled || !hasVolumePricing) {
    return false
  }

  return true
}
